import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import {
  MemoryRouter as Router,
} from "react-router-dom";
import {Switch} from 'react-router';
import {LicenseManager} from "@ag-grid-enterprise/core";

import EventBus from "./utils/microevent";
import LocalValues from "./utils/localValues";

import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { createTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import Auth0ProviderWithHistory from "./auth/auth0-provider-with-history";
import ProtectedRoute from "./auth/protected-route";

import './index.css';
import NewHome from './NewHome';
import FuelRates from './modules/Fuel/Fuel';
import FuelSuppliers from './modules/Companies/FuelSuppliers';
//import Settings from './Settings.js_old';
import Currencies from './modules/Currencies/Currencies';
import ExchangeRates from "./modules/Currencies/ExchangeRates";
import FuelExchangeRates from "./modules/Currencies/FuelExchangeRates";
import ExchangeRateProviders from "./modules/Currencies/ExchangeRateProviders";
import Trips from "./modules/Trips/Trips";
import FinanceTrips from "./modules/Trips/FinanceTrips";
import FlightPlanning from "./modules/FlightPlanning/FlightPlanning";
import Aircraft from "./modules/Aircraft/Aircraft";
import AircraftHoursPool from "./modules/Aircraft/AircraftHoursPool";
import UnitsOfMeasure from "./modules/Settings/UnitsOfMeasure";
import CargoMessageTypes from "./modules/Settings/CargoMessageTypes";
import InitializeCache from "./blocks/InitializeCache";
import FuelAnnexes from "./modules/Fuel/editors/FuelAnnexes";
import FuelContractAnnexes from "./modules/Fuel/FuelContractAnnexes";
import FuelMarkets from "./modules/Fuel/FuelMarkets";
import Companies from "./modules/Companies/Companies";
import CompanyManagement from "./modules/Companies/CompanyManagement";
import SageLedgerCodes from "./modules/Accounts/SageLedgerCodes";
import Contracts from "./modules/Contracts/Contracts";
import Permits from "./modules/Permits/PermitManagement";
import DocumentTemplates from "./modules/Settings/DocumentTemplates";
import FlightJetPlans from "./modules/Jeppesen/FlightJetPlans";
import Countries from "./modules/Settings/Countries";
import Airports from "./modules/Airports/Airports";
import CountryPermitRequirements from "./modules/PermitRequirements/CountryPermitRequirements";
import ShipmentTracking from "./modules/ShipmentTracking/ShipmentTracking";
import ComboValues from "./modules/Settings/ComboValues";
import BookingQueue from "./modules/Booking/BookingQueue";
import BookingList from "./modules/Booking/BookingList";
import SpotRequests from "./modules/Booking/SpotRequests";
import NewBooking from "./modules/Booking/NewBooking";
import SpecialLoadsRequest from "./modules/Booking/SpecialLoadRequest";
import SpecialLoadsRequests from "./modules/Booking/SpecialLoadRequests";
import InternalSpecialLoadRequest from "./modules/Booking/InternalSpecialLoadRequest";
import Tariff from "./modules/Tariff/Tariff";
import RouteRequiredPermitOverrides from "./modules/Permits/RouteRequiredPermitOverrides";
import Slots from "./modules/Slots/SlotManagement";
import FuelOrders from "./modules/Fuel/FuelOrders";
import HandlingOrders from "./modules/Handling/HandlingOrders";
import CateringOrders from "./modules/Catering/CateringOrders";
import FlightMonitor from "./modules/RampActions/FlightMonitor";
import Flights from "./modules/Flights/Flights";
import Persons from "./modules/Persons/Persons";
import UldTypeContours from './modules/Settings/UldTypeContours';
import MessageManagement from './modules/Messages/MessageManagement';
import Handover from './modules/Flights/Handover';
import NewSpotRequest from "./modules/Booking/NewSpotRequest";
import SlrReport from "./modules/Booking/SlrReport";
import CustomerBookingQueue from "./modules/Booking/CustomerBookingQueue";
import CustomerSpotRequests from "./modules/Booking/CustomerSpotRequests";
import CustomerNewBooking from "./modules/Booking/CustomerNewBooking";
import CustomerNewSpotRequest from "./modules/Booking/CustomerNewSpotRequest";
import FlightsExternalAccess from "./modules/Flights/FlightsExternalAccess";
import FlightCapacity from "./modules/Flights/FlightCapacity";
import AwbStockCustomerView from "./modules/AwbStock/AwbStockCustomerView";
import AwbStockManagement from "./modules/AwbStock/AwbStockManagement";
import OutstandingSpecialLoads from "./modules/Flights/OutstandingSpecialLoads";
import AircraftLoadabilityCheck from "./modules/Aircraft/AircraftLoadabilityCheck";
import RampActionsReport from "./modules/RampActions/RampActionsReport";
import Costings from "./modules/Costings/Costings";
import Enquiries from "./modules/Enquiry/Enquiries";
import NewEnquiry from "./modules/Enquiry/NewEnquiry";
import AirportFuelRestrictions from "./modules/Airports/AirportFuelRestrictions";
import CostingStructure from "./modules/Costings/CostingStructure";
import UploadCustomerBookingList from "./modules/Booking/UploadCustomerBookingList";
import MenuMaintenance from "./modules/Settings/MenuMaintenance";
import UldTracker from "./modules/Uld/UldTracker"
import RestrictedCommodities from "./modules/Settings/RestrictedCommodities";
import AnticipatedCostsReport from "./modules/Trips/AnticipatedCostsReport";
import AwbTracking from "./modules/ShipmentTracking/AwbTracking";
import FinanceBudgetReport from "./modules/Trips/FinanceBudgetReport";
import Commodities from "./modules/Settings/Commodities";


import * as serviceWorker from './serviceWorker';
import SystemContext from './SystemContext';

if (!Number.prototype.round) {
  // eslint-disable-next-line no-extend-native
  Number.prototype.round = function(places) {
    return +(Math.round(this + "e+" + places)  + "e-" + places);
  }
}

const queryClient = new QueryClient(
  {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    }
  }
);

setInterval(() => {
  const now = new Date();
  console.log(`running @ ${now}`);
  queryClient.invalidateQueries(["AircraftMovementsList"]);
  queryClient.invalidateQueries(["RampFlights"]);
  queryClient.invalidateQueries(["RampActions"]);
}, 60000);

const maerskPalette = {
  primary: {
    light: '#82CBE3',
    main: '#42b0d5',
    dark: '#1C657D',
    contrastText: '#fff',
  },
  secondary: {
    light: '#474747',
    main: '#202020',
    dark: '#000000',
    contrastText: '#fff',
  },
  background: {
    default: '#ffffff',
  },
  tableHeader: {
    textColor: '#ffffff',
    hoverColor: '#eeeeee',
    backgroundColor: '#42b0d5',
  },
  childTableHeader: {
    textColor: '#1C657D',
    hoverColor: '#42b0d5',
    backgroundColor: '#f5f5f5',
  },
  card: {
    backgroundColor: '#1C657D',
    contrastText: '#ffffff',
    content: {
      backgroundColor: '#ffffff',
      contrastText: '#1C657D',
    },
  },
  aogCard: {
    backgroundColor: '#9A0303',
    contrastText: '#ffffff',
    content: {
      backgroundColor: '#ffffff',
      contrastText: '#9A0303',
    },
  },
  maintenanceCard: {
    backgroundColor: '#815B2C',
    contrastText: '#ffffff',
    content: {
      backgroundColor: '#ffffff',
      contrastText: '#815B2C',
    },
  },
  returnToStandCard: {
    backgroundColor: '#ff3060',
    contrastText: '#ffffff',
    content: {
      backgroundColor: '#ffffff',
      contrastText: '#ff3060',
    },
  },
  externalCard: {
    backgroundColor: '#494949',
    contrastText: '#fc7c35',
    content: {
      backgroundColor: '#ffffff',
      contrastText: '#c12400',
    },
  },
};

const magmaPalette={
  primary: {
    light: '#ff8d3e',
    main: '#fc5b03',
    dark: '#c12400',
    contrastText: '#000',
  },
  secondary: {
    light: '#474747',
    main: '#202020',
    dark: '#000000',
    contrastText: '#fff',
  },
  background: {
    default: '#ffffff',
  },
  tableHeader: {
    textColor: '#fc7c35',
    hoverColor: '#ff8d3e',
    backgroundColor: '#3f3f3f',
  },
  childTableHeader: {
    textColor: '#c12400',
    hoverColor: '#fc5b03',
    backgroundColor: '#eaeaea',
  },
  card: {
    backgroundColor: '#494949',
    contrastText: '#fc7c35',
    content: {
      backgroundColor: '#ffffff',
      contrastText: '#c12400',
    },
  },
  aogCard: {
    backgroundColor: '#9A0303',
    contrastText: '#ffffff',
    content: {
      backgroundColor: '#ffffff',
      contrastText: '#9A0303',
    },
  },
  maintenanceCard: {
    backgroundColor: '#815B2C',
    contrastText: '#ffffff',
    content: {
      backgroundColor: '#ffffff',
      contrastText: '#815B2C',
    },
  },
  returnToStandCard: {
    backgroundColor: '#ff3060',
    contrastText: '#ffffff',
    content: {
      backgroundColor: '#ffffff',
      contrastText: '#ff3060',
    },
  },
  externalCard: {
    backgroundColor: '#1C657D',
    contrastText: '#ffffff',
    content: {
      backgroundColor: '#ffffff',
      contrastText: '#1C657D',
    },
  },
};

const darkPalette={
  primary: {
    light: '#ff8d3e',
    main: '#fc5b03',
    dark: '#c12400',
    contrastText: '#fff',
  },
  secondary: {
    light: '#474747',
    main: '#f0f0f0',
    dark: '#ffffff',
    contrastText: '#fff',
  },
  background: {
    default: '#303030',
  },
  tableHeader: {
    textColor: '#fc7c35',
    hoverColor: '#ff8d3e',
    backgroundColor: '#3f3f3f',
  },
  childTableHeader: {
    textColor: '#c12400',
    hoverColor: '#fc5b03',
    backgroundColor: '#eaeaea',
  },
  card: {
    backgroundColor: '#494949',
    contrastText: '#fc7c35',
    content: {
      backgroundColor: '#ffffff',
      contrastText: '#c12400',
    },
  },
  aogCard: {
    backgroundColor: '#9A0303',
    contrastText: '#ffffff',
    content: {
      backgroundColor: '#ffffff',
      contrastText: '#9A0303',
    },
  },
  maintenanceCard: {
    backgroundColor: '#815B2C',
    contrastText: '#ffffff',
    content: {
      backgroundColor: '#ffffff',
      contrastText: '#815B2C',
    },
  },
  returnToStandCard: {
    backgroundColor: '#ff3060',
    contrastText: '#ffffff',
    content: {
      backgroundColor: '#ffffff',
      contrastText: '#ff3060',
    },
  },
};

const palette = process.env.REACT_APP_COMPANY === 'MAERSK' ? maerskPalette : magmaPalette;

const baseTheme = createTheme(
  {
    $secondaryMain:'#202020',
    palette: {...palette},
    typography: {
      fontSize: 13,
    },
    dataGridSelector: {
      display: 'inline-block',
      width: '100%'
    },
    overrides: {
      MuiTooltip: {
        tooltip: {
          backgroundColor: "#616161",
        }
      },
      MuiTableSortLabel: {
        root: {
          color: palette.tableHeader.textColor,
          '&:hover': {
            color: palette.tableHeader.hoverColor,
          },
        },
        active: {
          color: palette.tableHeader.hoverColor,
        },
      },
      MuiTable: {
        root: {
          "& .MuiTable-root": {
            "& .MuiTableSortLabel-root": {
              color: palette.childTableHeader.textColor,
              '&:hover': {
                color: palette.childTableHeader.hoverColor,
              },
            },
            active: {
              color: palette.childTableHeader.hoverColor,
            },
          },
        }
      },
      MuiTableRow: {
        root: {
          fontSize: 13,
        }
      },
      MuiTableCell: {
        root: {
          fontSize: 13,
        },
      },
      MuiInput: {
        underline: {
          [`&.readOnly:before`]: {
            borderBottom: `1px dotted`,
          },
          [`&.readOnly:hover:before`]: {
            borderBottom: `1px dotted`,
          },
          [`&.readOnly:focused:before`]: {
            borderBottom: `1px dotted`,
          },
          [`&.readOnly:after`]: {
            borderBottom: `0px solid`,
            transform: 'scaleX(0)',
          },
          [`&.onDataGrid:after`]: {
            borderBottom: `0px solid`,
            transform: 'scaleX(0)',
          },
          [`&.onDataGrid:before`]: {
            borderBottom: `0px solid`,
          },
          [`&.onDataGrid:hover:after`]: {
            borderBottom: `0px solid`,
            transform: 'scaleX(0)',
          },
          [`&.onDataGrid:hover:before`]: {
            borderBottom: `0px solid`,
          },
          [`&.onDataGrid:focussed`]: {
            background: `none`,
          },

        }
      },
      MuiFormControlLabel: {
        labelPlacementTop: {
          [`& .MuiFormControlLabel-label`]: {
            transform: "translate(0, 1.5px) scale(0.75)",
            color: "rgba(0, 0, 0, 0.54)",
          },
          [`&.readOnly .MuiFormControlLabel-label`]: {
            color: "rgba(0, 0, 0, 0.54)",
          },
          [`&.readOnly .MuiIconButton-label`]: {
            color: palette.secondary.main
          }
        }
      },
      MuiInputAdornment: {
        positionStart: {
          [`& .filterIcon`]: {
            fontSize: 10
          },
        }
      },
      MuiCheckbox: {
        colorSecondary: {
          [`&.readOnly.Mui-disabled`]: {
            color: "rgba(0, 0, 0, 0.54)"
          }
        }
      }
    }
  }
);

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    ...darkPalette
  },
})

function Themed() {
  LicenseManager.setLicenseKey("CompanyName=Forward Momentum,LicensedApplication=Charter Management System,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-031132,SupportServicesEnd=31_July_2023_[v2]_MTY5MDc1ODAwMDAwMA==50198e368b94df4af83d0323051e7467");

  let prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  console.log("prefersDarkMode", prefersDarkMode);
  prefersDarkMode = false;

  const [SystemData, setSystemData] = useState({
    contractTypes: ['CONTRACTED', 'AD-HOC'],
    pricePeriods: ['Monthly', 'Weekly', 'Fortnightly', 'Spot'],
    contactTypes: ['COMPANY', 'PERSON','AGENT'],
    contactMethods: ["Email", "Phone", "Mobile", "Fax", "SITA", "AFTN", "Postal Address"],
    ediMethods: ["AFTN", "Email", "FTP", "PIMA", "SITA", "SFTP"],
    fuelOrderProcess: ["EMAIL", "PHONE", "WEB"],
    eventBus: EventBus,
    localValues: LocalValues,
    menuItems:[],
    goHome: () => {},
    formatChars: {
      "U": "[A-Z]",
      "A": "[A-Z0-9]",
      "a": "[A-Za-z0-9]",
      "i": "[A-Za-z0-9\\-]",
      "9": "[0-9]",
      "D": "[0-9.]",
      "-": "-",
      "x": "."
    }
  });
  const updateSystemData = (changes) => {
    if (changes && Array.isArray(changes.menuItems) && changes.menuItems.length > 0) {
      changes['goHome'] = (history) => {
        history.push(changes.menuItems[0]?.path||'/');
      }
    }
    setSystemData({...SystemData, ...changes});
  }

  return (
    <div>
      <SystemContext.Provider value={SystemData}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={prefersDarkMode ? darkTheme : baseTheme}>
            <div className="App">
              <Router>
                <Auth0ProviderWithHistory>
                  <DndProvider backend={HTML5Backend}>
                    <div className="content">
                    <Switch>
                      <ProtectedRoute exact path="/fuel" component={FuelRates}/>
                      <ProtectedRoute exact path="/fuel/rates" component={FuelRates} />
                      <ProtectedRoute exact path="/fuel/annexes" component={FuelContractAnnexes} />
                      <ProtectedRoute exact path="/fuel/suppliers" component={FuelSuppliers} />
                      <ProtectedRoute exact path="/fuel/markets" component={FuelMarkets} />
                      <ProtectedRoute exact path="/fuel/exchangerates" component={FuelExchangeRates} />
                      <ProtectedRoute exact path="/permitmanagement" component={Permits} />
                      <ProtectedRoute exact path="/countries/permitrequirements" component={CountryPermitRequirements} />
                      <ProtectedRoute exact path="/flightjetplans" component={FlightJetPlans} />
                      <ProtectedRoute exact path="/routerequiredpermitoverrides" component={RouteRequiredPermitOverrides} />
                      <ProtectedRoute exact path="/editors/annexes" component={FuelAnnexes} />
                      <ProtectedRoute exact path="/editors/persons" component={Persons} />
                      <ProtectedRoute exact path="/editors/messagemanagement" component={MessageManagement} />
                      <ProtectedRoute exact path="/combovalues" component={ComboValues} />
                      <ProtectedRoute exact path="/contracts" component={Contracts} />
                      <ProtectedRoute exact path="/contracts/contracts" component={Contracts} />
                      <ProtectedRoute exact path="/shipments/awbtracking" component={AwbTracking} />
                      <ProtectedRoute exact path="/shipments/shipmenttracking" component={ShipmentTracking} />
                      <ProtectedRoute exact path="/shipments/uldtracking" component={UldTracker} />
                      <ProtectedRoute exact path="/accounts/sageledgercodes" component={SageLedgerCodes} />
                      {/* <ProtectedRoute exact path="/settings" component={Settings}/> */}
                      <ProtectedRoute exact path="/currencies" component={Currencies}/>
                      <ProtectedRoute exact path="/exchangerates" component={ExchangeRates}/>
                      <ProtectedRoute exact path="/countries" component={Countries}/>
                      <ProtectedRoute exact path="/airports" component={Airports}/>
                      <ProtectedRoute exact path="/aircraft" component={Aircraft}/>
                      <ProtectedRoute exact path="/aircrafthourspool" component={AircraftHoursPool}/>
                      <ProtectedRoute exact path="/settings/airwaybillstock" component={AwbStockManagement}/>
                      <ProtectedRoute exact path="/settings/commodities" component={Commodities}/>
                      <ProtectedRoute exact path="/booking/customerawbstock" component={AwbStockCustomerView}/>
                      <ProtectedRoute exact path="/unitsofmeasure" component={UnitsOfMeasure}/>
                      <ProtectedRoute exact path="/messagetypes" component={CargoMessageTypes}/>
                      <ProtectedRoute exact path="/documenttemplates" component={DocumentTemplates}/>
                      <ProtectedRoute exact path="/exchangerateproviders" component={ExchangeRateProviders}/>
                      <ProtectedRoute exact path="/flightplanning" component={FlightPlanning}/>
                      <ProtectedRoute exact path="/trips" component={Trips}/>
                      <ProtectedRoute exact path="/trips/trips" component={Trips}/>
                      <ProtectedRoute exact path="/trips/financetrips" component={FinanceTrips}/>
                      <ProtectedRoute exact path="/flights/flights" component={Flights}/>
                      <ProtectedRoute exact path="/flights/flightcapacity" component={FlightCapacity}/>
                      <ProtectedRoute exact path="/flights/handover" component={Handover}/>
                      <ProtectedRoute exact path="/flights/flightsexternalaccess" component={FlightsExternalAccess}/>
                      <ProtectedRoute exact path="/flights/outstandingspecialloads" component={OutstandingSpecialLoads}/>
                      <ProtectedRoute exact path="/trips/slots" component={Slots}/>
                      <ProtectedRoute exact path="/trips/fuelorders" component={FuelOrders}/>
                      <ProtectedRoute exact path="/trips/handlingorders" component={HandlingOrders}/>
                      <ProtectedRoute exact path="/trips/cateringorders" component={CateringOrders}/>
                      <ProtectedRoute exact path="/trips/anticipatedcosts" component={AnticipatedCostsReport}/>
                      <ProtectedRoute exact path="/trips/financebudget" component={FinanceBudgetReport}/>
                      <ProtectedRoute exact path="/companies" component={Companies}/>
                      <ProtectedRoute exact path="/companymanagement" component={CompanyManagement}/>
                      <ProtectedRoute exact path="/booking/bookingqueue" component={BookingQueue}/>
                      <ProtectedRoute exact path="/booking/bookingsheet" component={BookingList}/>
                      <ProtectedRoute exact path="/booking/spotrequests" component={SpotRequests}/>
                      <ProtectedRoute exact path="/booking/newbooking" component={NewBooking}/>
                      <ProtectedRoute exact path="/booking/newspotrequest" component={NewSpotRequest}/>
                      <ProtectedRoute exact path="/booking/specialloadsrequest" component={SpecialLoadsRequest}/>
                      <ProtectedRoute exact path="/booking/specialloadrequests" component={SpecialLoadsRequests}/>
                      <ProtectedRoute exact path="/booking/internalspecialloadsrequest" component={InternalSpecialLoadRequest}/>
                      <ProtectedRoute exact path="/booking/slrreport" component={SlrReport}/>
                      <ProtectedRoute exact path="/booking/customerbookingqueue" component={CustomerBookingQueue}/>
                      <ProtectedRoute exact path="/booking/customerspotrequests" component={CustomerSpotRequests}/>
                      <ProtectedRoute exact path="/booking/customernewbooking" component={CustomerNewBooking}/>
                      <ProtectedRoute exact path="/booking/customernewspotrequest" component={CustomerNewSpotRequest}/>
                      <ProtectedRoute exact path="/booking/uploadcustomerbookinglist" component={UploadCustomerBookingList}/>
                      <ProtectedRoute exact path="/tariff" component={Tariff}/>
                      <ProtectedRoute exact path="/monitors/flightmonitor" component={FlightMonitor}/>
                      <ProtectedRoute exact path="/monitors/rampactionsreport" component={RampActionsReport}/>
                      <ProtectedRoute exact path="/uldtypecontours" component={UldTypeContours}/>
                      <ProtectedRoute exact path="/loadability/loadabilitycheck" component={AircraftLoadabilityCheck}/>
                      <ProtectedRoute exact path="/costings/costings" component={Costings}/>
                      <ProtectedRoute exact path="/enquiry/enquiries" component={Enquiries}/>
                      <ProtectedRoute exact path="/enquiry/newenquiry" component={NewEnquiry}/>
                      <ProtectedRoute exact path="/costings/costingstructure" component={CostingStructure}/>
                      <ProtectedRoute exact path="/airportFuelRestrictions" component={AirportFuelRestrictions}/>
                      <ProtectedRoute exact path="/settings/menumaintenance" component={MenuMaintenance}/>
                      <ProtectedRoute exact path="/settings/restrictedcommodities" component={RestrictedCommodities}/>

                      <ProtectedRoute exact path="/" component={NewHome}/>
                    </Switch>
                    </div>
                    <InitializeCache SystemData={SystemData} onChange={(changes)=>updateSystemData(changes)}/>
                  </DndProvider>
                </Auth0ProviderWithHistory>
              </Router>
            </div>
          </ThemeProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </SystemContext.Provider>
    </div>
  );
}

ReactDOM.render(<Themed />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
